
URL = globalThis.URL
import __vite__wasmUrl from "/opt/build/repo/clients/web/node_modules/.pnpm/@crabnebula+file-icons@0.1.0/node_modules/@crabnebula/file-icons/dist/file_icons-KM7ZT43I.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"


const __vite__wasmModule = await __vite__initWasm({  }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const _get_icon_for_file = __vite__wasmModule._get_icon_for_file;
export const _get_icon_for_folder = __vite__wasmModule._get_icon_for_folder;
export const __data_end = __vite__wasmModule.__data_end;
export const __heap_base = __vite__wasmModule.__heap_base;
